/**
 * @generated SignedSource<<e193cf82b572ba5014df5e2cf360497e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PromotionStatusEnum = "finished" | "ongoing" | "preparing" | "scheduled" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PromotionStatusLabel_promotion$data = {
  readonly status: PromotionStatusEnum;
  readonly " $fragmentType": "PromotionStatusLabel_promotion";
};
export type PromotionStatusLabel_promotion$key = {
  readonly " $data"?: PromotionStatusLabel_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionStatusLabel_promotion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromotionStatusLabel_promotion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Promotion",
  "abstractKey": null
};

(node as any).hash = "49eb0d5a5d6a0870df5b64a30ba0e2ce";

export default node;
